// 定义英文语言包对象
export default {
    Language: 'English',
    signIn: 'Sign In',
    navigateBar: {
        homePage: 'Home Page',
        newsInformation: 'News Information',
        productCenter: 'Product Center',
        aboutUs: 'About Us',
    },
    title: {
        companyName: 'CCT（HK）LIMITED',
        slogan: 'Pursuing ultimate creativity',
        newsInformation: 'News Information',
        productCenter: 'Product Center',
        aboutUs: 'Entering CCT',
        companyNews: 'Company News',
        industryNews: 'Industry News',
    },
    aboutUs:{
        aboutUs: 'About Us',
        aboutUsText: 'CCT (HK) LIMITED was founded in 2007 and is one of the earliest pioneers in the electronic cigarette industry. It has established a complete quality management system and strong research and development capabilities, with over 400 domestic and foreign patent authorization records.',
        developmentHistory: 'Development History',
        corporateCulture: 'Corporate Culture',
        corporateCultureText1: 'Customer First: Always prioritize user needs and strive to provide safe, high-quality, and innovative products and services',
        corporateCultureText2: 'Integrity management: Adhere to honesty, abide by laws and regulations, adhere to business ethics, and maintain a good industry ecology',
        corporateCultureText3: 'Innovation driven: Encourage innovative thinking, continuously invest in research and development, promote technological progress, and bring users a better product experience',
        corporateCultureText4: 'Win win cooperation: Working hand in hand with partners to establish long-term stable cooperative relationships and achieve mutual benefit and win-win outcomes',
        corporateCultureText5: 'Social Responsibility: Actively fulfilling social responsibility, paying attention to the protection of young people, advocating rational consumption, and contributing to social development',
        qualificationAndHonor: 'International Qualification Certification',
        team: 'Team',
        cooperativePartner: 'Cooperative Partner',
        clickImage: 'Click on the image to view a larger image',
    },
    footer: {
        aboutUs: 'Entering CCT',
        newsInformation: 'News and Information',
        productCenter: 'Product Center',
        contactUs: 'Contact Us',
        child:{
            developmentHistory: 'Development History',
            corporateCulture: 'Corporate Culture',
            qualificationAndHonor: 'International Qualification Certification',
            cooperativePartner: 'Cooperative Partner',
            companyNews: 'Company News',
            industryNews: 'Industry News',
            productIntroduction: 'Product Introduction',
            email: 'Email: garyking0073@gmail.com',
            phone: 'Tel: 852-88881234',
            address: 'Address: FLAT G 2/F LEAPONT CTR 18-28 WO LIU HANG RD FO TAN HONG KONG',
        }
    },
};
